import { useCallback, useContext, useEffect, useState } from "react";
import Loader from "../../components/Loader";
import { Link, useNavigate } from "react-router-dom";
import { Grid2 } from "@mui/material";
import StyledGridComp from "../../components/StyledGridComp";
import { fetchAllDrugTypeManagementService } from "../../services/drugTypeManagementService";
import { notifyError } from "../../utilities/helper";
import SearchedComponent from "../../components/SearchedComponent";
import { MenuContext } from "../../App";
import useDebounceSearch from "../../hooks/useDebounceSearch";
import { Home } from "@mui/icons-material";

const DrugTypeManagement = () => {
  const [load, setLoad] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [rowData, setRowData] = useState([]);
  const [rowLength, setRowLength] = useState(0);
  const [searchedValue, setSearchedValue] = useState("");
  const [canAddDrugType, setCanAddDrugType] = useState(false);

  const navigate = useNavigate();
  const { systemActions } = useContext(MenuContext);

  const debounceQuery = useDebounceSearch(searchedValue, 500);

  const access_token = localStorage?.getItem("access_token");
  const role = localStorage.getItem("role");

  useEffect(() => {
    if (page >= 0 && pageSize && access_token) {
      getAllDrugTypeData(pageSize, page, access_token, debounceQuery);
    }
  }, [page, pageSize, access_token, debounceQuery]);

  useEffect(() => {
    if (systemActions?.length > 0 && role !== "Admin") {
      let canAdd = false;
      const createFound = systemActions?.find(
        (item) => item?.name === "CanCreateDrugType",
      );
      if (createFound) {
        canAdd = true;
      }
      setCanAddDrugType(canAdd);
    } else if (role === "Admin") {
      setCanAddDrugType(true);
    }
  }, [systemActions]);

  const getAllDrugTypeData = async (
    pageSize,
    page,
    access_token,
    debouncedSearch = "",
  ) => {
    setLoad(true);
    try {
      const res = await fetchAllDrugTypeManagementService(
        page + 1,
        pageSize,
        access_token,
        debouncedSearch,
      );
      if (res?.status == 200) {
        setLoad(false);
        setRowData(res?.data?.result);
        setRowLength(res?.data?.totalCount);
      }
    } catch (err) {
      setLoad(false);
      notifyError(err?.mesage);
      console.log(err);
      if (err?.status == 401) {
        navigate("/unauthorize");
      }
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      width: 250,
      renderHeader: () => <div className="grid-heading">{"Name"}</div>,
      renderCell: (params) => {
        const name = params.row.name;
        const id = params.row.id;

        return (
          <button
            className="bread-crumbs-link grid-nav-btn"
            onClick={() => {
              navigate("/addUpdate-drug-type", {
                state: {
                  id: id,
                },
              });
            }}
          >
            {name}
          </button>
        );
      },
    },
    {
      field: "code",
      headerName: "Drug Id",
      width: 250,
      renderHeader: () => <div className="grid-heading">{"Drug Id"}</div>,
      renderCell: (params) => {
        const code = params.row.code;

        return <span className="data-font">{code}</span>;
      },
    },
    {
      field: "packageName",
      headerName: "Package Type",
      width: 250,
      renderHeader: () => <div className="grid-heading">{"Package Type"}</div>,
      renderCell: (params) => {
        const packageName = params.row.packageName;

        return <span className="data-font">{packageName}</span>;
      },
    },
    {
      field: "isBulk",
      headerName: "Bulk Drug",
      width: 200,
      renderHeader: () => <div className="grid-heading">{"Bulk Drug?"}</div>,
      renderCell: (params) => {
        const isBulk = params.row.isBulk;

        return <span className="data-font">{isBulk ? "True" : "False"}</span>;
      },
    },
    {
      field: "maxReturnablePillCount",
      headerName: "Full Pill Count",
      width: 250,
      renderHeader: () => (
        <div className="grid-heading">{"Full Pill Count"}</div>
      ),
      renderCell: (params) => {
        const maxReturnablePillCount = params.row.maxReturnablePillCount;

        return <span className="data-font">{maxReturnablePillCount}</span>;
      },
    },
  ];

  const handleSearch = useCallback((e) => {
    setSearchedValue(e.target.value);
  }, []);

  return (
    <>
      <div className="content-body">
        <div className="home-container">
          <p
            className="bread-crumbs-link-container"
            style={{ fontWeight: "600" }}
          >
            <Link className="bread-crumbs-link" to="/">
              Home
            </Link>{" "}
            |{" "}
            <Link className="bread-crumbs-link" to="/drug-type">
              Drug Types
            </Link>
            -{" "}
            <b style={{ color: "gray" }}>
              {localStorage?.getItem("studyName")}
            </b>
          </p>
          <Link className="bread-crumbs-link home-inner-container">
            Set as Home Page
            <span>
              <Home
                sx={{
                  fontSize: "20px",
                }}
              />
            </span>
          </Link>
        </div>
        <Grid2
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: "100%", margin: "0 auto" }}
        >
          <Grid2 item md={6}>
            <p className="page-heading">Drug Types</p>
          </Grid2>
          <Grid2 item md={6}>
            <div className="search-bar-container">
              <SearchedComponent
                handleSearch={handleSearch}
                placeholder="Drug Type"
                searchedValue={searchedValue}
              />
              {canAddDrugType && (
                <button
                  className="create-btn"
                  onClick={() => navigate("/addUpdate-drug-type")}
                >
                  Add New Drug Type
                </button>
              )}
            </div>
          </Grid2>
        </Grid2>

        {load ? (
          <Loader />
        ) : (
          <StyledGridComp
            rows={rowData}
            columns={columns}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            length={rowLength}
          ></StyledGridComp>
        )}

        <Grid2
          alignItems={"end"}
          justifyContent="end"
          container
          sx={{ marginTop: "2%" }}
        >
          <Grid2 item md={6}>
            <button className="create-btn">Back</button>
          </Grid2>
        </Grid2>
      </div>
    </>
  );
};

export default DrugTypeManagement;
